import React, { useEffect, useState } from 'react'

const OnboardingImage: React.FC = () => {
    const [subdomain, setSubDomain] = useState<string>('default')

    useEffect(() => {
        const hostname = window.location.hostname
        const subdomain = hostname.split('.')[0]
        if (subdomain === 'dann' || subdomain === 'localhost' || subdomain === 'www' || subdomain === 'dann-frontend') {
            setSubDomain('default')
        } else {
            setSubDomain(subdomain)
        }
    }, [])

    return (
        <img
            className="absolute inset-0 h-full w-full object-cover object-top"
            src={`/assets/img/${subdomain}-onboarding.jpg`}
            alt=""
        />
    )
}

export default OnboardingImage
